import React from 'react';

/**
 * v2 card — radius 10, depth from the 1px border only (no drop shadow).
 * Header type is card-header (13.5/700). `ai` variant gets the blue→violet
 * wash ONLY because it carries AI content.
 */
export interface CardProps {
  title?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  /** AI-carrying container — subtle ai gradient + robbie border */
  ai?: boolean;
  padded?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  actions,
  footer,
  ai,
  padded = true,
  children,
  className = '',
}) => (
  <section
    className={
      `rounded-card border ${ai ? 'border-robbie-border-soft bg-ai-panel' : 'border-line bg-surface'} ` + className
    }
  >
    {(title || actions) && (
      <header className={`flex items-center justify-between gap-s3 px-s6 py-s4 border-b ${ai ? 'border-robbie-border-soft' : 'border-line-divider'}`}>
        {title && <h3 className="text-card-header text-ink">{title}</h3>}
        {actions && <div className="flex items-center gap-s2">{actions}</div>}
      </header>
    )}
    <div className={padded ? 'px-s6 py-s5' : ''}>{children}</div>
    {footer && (
      <footer className={`px-s6 py-s4 border-t ${ai ? 'border-robbie-border-soft' : 'border-line-divider'}`}>
        {footer}
      </footer>
    )}
  </section>
);

export default Card;
